<template>
    <div>
        <v-card flat>
            <v-card-title>
                <span class="text-h5">{{ title }}</span>
                <v-btn icon href="https://files.gestionuniformes.cl/unf/EmpleadosMasivos.xlsx" target="_blank">
                    <v-icon color="green">mdi-microsoft-excel</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" md="8">
                            <v-file-input v-model="currentFile" label="Seleccionar archivo Excel (.xlsx, .xls)"
                                accept=".xlsx, .xls" placeholder="Haz clic para buscar el archivo"
                                prepend-icon="mdi-microsoft-excel" outlined dense @change="resetData"></v-file-input>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-btn color="success" class="white--text" :disabled="!currentFile" @click="readExcelFile"
                                block>
                                Procesar Archivo
                            </v-btn>
                        </v-col>
                    </v-row>

                    <div v-if="excelData.length > 0">
                        <v-divider class="my-3"></v-divider>
                        <p class="subtitle-1">Vista previa de datos ({{ excelData.length }} filas):</p>
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
                            hide-details></v-text-field>
                        <v-data-table :headers="headers" :items="excelData" :items-per-page="5" :search="search"
                            class="elevation-1 custom-font">
                            <template v-slot:item.flag="{ item }">
                                <v-icon :color="item.flag ? 'green' : 'red'">
                                    {{ item.flag ? 'mdi-check-circle' : 'mdi-alert-circle' }}
                                </v-icon>
                            </template>
                        </v-data-table>
                    </div>

                    <div v-else-if="loading" class="text-center py-5">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                        <p>Leyendo archivo...</p>
                    </div>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-alert shaped dense dark type="error" v-if="error">
                    Se han detectado filas con errores
                </v-alert>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="cancelAction">
                    Cancelar
                </v-btn>
                <v-btn color="blue darken-1" text @click="confirmData"
                    v-if="excelData.length > 0 && this.error === false">
                    Crear Empleados
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import * as XLSX from 'xlsx';
import { headersMassiveEmployees } from "../commons/headers";
import { formatRut, validateRut, cleanRut } from 'rutlib';
import validateEmail from '../tools/validateEmail';
export default {
    name: 'UploadMasiveEmploys',
    props: {
        title: {
            type: String,
            default: 'Carga Masiva de Empleados'
        }
    },
    data: () => ({
        currentFile: null,
        excelData: [],
        headers: headersMassiveEmployees,
        loading: false,
        error: false,
        search: ''
    }),
    methods: {
        // Limpia la tabla si el usuario cambia el archivo
        resetData() {
            this.excelData = [];
        },

        cancelAction() {
            this.$emit("closeModal");
            this.currentFile = null;
            this.resetData();
        },

        confirmData() {
            // Emite los datos al padre para que haga algo con ellos (ej. guardarlos en BD)
            this.$emit('confirmData', this.excelData);
        },

        readExcelFile() {
            if (!this.currentFile) return;

            this.loading = true;
            const reader = new FileReader();

            reader.onload = (e) => {
                try {
                    const data = e.target.result;

                    // 1. Leer el libro
                    const workbook = XLSX.read(data, { type: 'array' });

                    // 2. Tomar la primera hoja
                    const firstSheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[firstSheetName];

                    // 3. Convertir a JSON
                    const jsonData = XLSX.utils.sheet_to_json(worksheet);

                    console.log("🚀 Datos leídos del Excel:", jsonData);

                    if (jsonData.length > 0) {
                        const processedData = jsonData.map(excelRow => {
                            return this.processRow(excelRow);
                        });

                        this.excelData = processedData;
                    } else {
                        console.warn("El archivo Excel está vacío o no se pudo leer correctamente.");
                    }

                } catch (error) {
                    console.error("Error al leer el archivo Excel:", error);
                } finally {
                    this.loading = false;
                }
            };

            reader.readAsArrayBuffer(this.currentFile);
        },

        processRow(excelRow) {
            let flag = true;
            const newRow = {};

            this.headers.forEach(header => {
                const fieldKey = header.value;
                let value = excelRow[fieldKey];

                if (typeof value === 'string') {
                    value = value.trim().toUpperCase();
                }

                switch (fieldKey) {
                    case 'rut':
                    case 'managerRut':
                        if (value && typeof value === 'string' && value.trim() !== '' && validateRut(value)) {
                            value = formatRut(cleanRut(value), false);
                        } else {
                            flag = false;
                        }
                        break;
                    case 'motherName':
                    case 'flag':
                        break;
                    case 'email':
                        if (value && typeof value === 'string' && value.trim() !== '' && validateEmail(value)) {
                            value = value.trim().toLowerCase();
                        } else {
                            flag = false;
                        }
                        break;
                    default:
                        if (value === null || value === undefined || value === '') {
                            flag = false;
                        }
                }
                newRow[fieldKey] = value;
            });
            newRow['flag'] = flag;
            if (!flag) this.error = true;
            return newRow;
        },
    }
}
</script>

<style scoped>
.custom-font {
    font-size: 0.9rem;
}
</style>